import { BASE_URL } from "../constants/constants";

const DEFAULT_SOCKET_TRANSPORTS = ["polling", "websocket"];
const VALID_SOCKET_TRANSPORTS = new Set(["polling", "websocket", "webtransport"]);

const trimTrailingSlash = (value) => String(value || "").trim().replace(/\/+$/, "");

const firstNonEmpty = (...values) => {
  for (const value of values) {
    if (value != null && String(value).trim() !== "") return String(value).trim();
  }
  return "";
};

export const parseSocketTransports = (value, fallback = DEFAULT_SOCKET_TRANSPORTS) => {
  const transports = String(value || "")
    .split(",")
    .map((transport) => transport.trim())
    .filter((transport) => VALID_SOCKET_TRANSPORTS.has(transport));

  return transports.length ? transports : [...fallback];
};

const originFromUrl = (value) => {
  try {
    return trimTrailingSlash(new URL(value).origin);
  } catch (error) {
    return "";
  }
};

export const getSocketBaseUrl = ({
  env = process.env,
  baseUrl = BASE_URL,
} = {}) => {
  const configuredBaseUrl = firstNonEmpty(env.REACT_APP_BASE_URL, env.BASE_URL);
  if (configuredBaseUrl) return trimTrailingSlash(configuredBaseUrl);

  const configuredApiUrl = firstNonEmpty(env.REACT_APP_BASE_URL_API, env.BASE_URL_API);
  const apiOrigin = originFromUrl(configuredApiUrl);
  if (apiOrigin) return apiOrigin;

  return trimTrailingSlash(baseUrl);
};

export const buildSocketClientOptions = ({
  token = "",
  env = process.env,
} = {}) => ({
  auth: {
    token,
  },
  transports: parseSocketTransports(
    firstNonEmpty(env.REACT_APP_SOCKET_IO_TRANSPORTS, env.SOCKET_IO_TRANSPORTS)
  ),
  upgrade: true,
  rememberUpgrade: false,
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: Infinity,
  timeout: 20000,
  forceNew: false,
  withCredentials: false,
  autoConnect: false,
});
